<template>
    <viemao-header :isPc="isPc" style="padding-top: 0px"></viemao-header>
    <div :class="{ web: isPc, mobile: !isPc }">
        <div class="head">
            <div class="headInfo">
                <p class="headSubTitle">{{ head.headSubTitle }}</p>
                <h1 class="headTitle">{{ head.headTitle }}</h1>
                <p class="headText">{{ head.headText }}</p>
            </div>
        </div>
        <div class="body">
            <div class="bodyInfo">
                <p class="bodyIntro" v-html="body.bodyIntro"></p>
                <template v-for="item in body.bodyInfoArr" :key="item.name">
                    <template v-if="item.type === 'h2'">
                        <h2 v-html="item.name"></h2>
                    </template>
                    <template v-else-if="item.type === 'h3'">
                        <h3 v-html="item.name"></h3>
                    </template>
                    <template v-else>
                        <p v-html="item.name"></p>
                    </template>
                    <p v-if="item.body" v-html="item.body"></p>
                    <template v-if="item.bodyEnum">
                        <ul>
                            <li v-for="(value, index) in item.bodyEnum" :key="index">
                                <p class="index bodyEnumItem" v-html="index + 1 + '.'"></p>
                                <p v-html="value" class="value bodyEnumItem"></p>
                            </li>
                            <ul v-if="item.bodySonEnum">
                                <li v-for="(value, index) in item.bodySonEnum" :key="index">
                                    <p class="index bodyEnumItem" v-html="index + 1 + '.'"></p>
                                    <p v-html="value" class="value bodyEnumItem"></p>
                                </li>
                            </ul>
                        </ul>
                    </template>
                </template>
            </div>
        </div>
    </div>
    <viemao-footer :isPc="isPc"></viemao-footer>
</template>

<script setup>
import { onMounted } from "vue";
import viemaoHeader from "../viemaoHeader.vue";
import viemaoFooter from "../viemaoFooter.vue";
import uesUpdateSize from "@/helpers/useUpdateSize";

const { isPc } = uesUpdateSize();

defineProps({
    head: {
        type: Object,
        required: true,
        default: () => ({
            headSubTitle: "",
            headTitle: "",
            headText: "",
        }),
    },
    body: {
        type: Object,
        required: true,
        default: () => ({
            bodyIntro: "",
            bodyInfoArr: [],
        }),
    },
});

onMounted(() => {
    window.scrollTo(0, 0);
});
</script>

<style scoped lang="scss">
.web {
    width: 100%;
    padding-top: 68px;
    .head {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 96px 0;
        box-sizing: border-box;
        .headInfo {
            width: 66%;
            text-align: center;
            .headSubTitle {
                font-family: "Inter-Medium" !important;
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                color: $Brand600;
                margin-bottom: 12px;
            }
            .headTitle {
                font-family: "Inter-Semibold" !important;
                font-size: 48px;
                font-weight: 600;
                line-height: 60px;
                color: $Gray1200;
                margin-bottom: 24px;
            }
            .headText {
                font-family: "Inter-Regular" !important;
                font-size: 20px;
                font-weight: 400;
                line-height: 30px;
                color: $Gray700;
            }
        }
    }
    .body {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 0 0 96px 0;
        box-sizing: border-box;
        .bodyInfo {
            width: 720px;
            p {
                line-height: 28px;
                font-size: 18px;
                font-weight: 400;
                font-family: "Inter-Regular" !important;
                color: $Gray700;
                margin-bottom: 28px;
            }
            h2 {
                font-family: "Inter-Medium" !important;
                font-size: 30px;
                font-weight: 500;
                line-height: 38px;
                color: $Gray1200;
                margin: 40px 0 20px 0;
            }
            h3 {
                color: $Gray1200;
                font-family: "Inter-Medium" !important;
                font-size: 20px;
                font-weight: 500;
                line-height: 30px;
                margin-bottom: 12px;
            }
            ul {
                width: 100%;
                padding: 0 0 0 10px;
                box-sizing: border-box;
                li {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 28px;
                    color: $Gray700;
                    list-style-type: none;
                    .bodyEnumItem {
                        margin-bottom: 0;
                    }
                    .index {
                        width: 24px;
                        text-align: right;
                    }
                    .value {
                        width: 680px;
                    }
                }

                ul {
                    padding: 0 0 0 20px;
                    box-sizing: border-box;
                    li {
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 28px;
                        color: $Gray700;
                        list-style-type: none;
                        .bodyEnumItem {
                            margin-bottom: 0;
                        }
                        .index {
                            width: 24px;
                            text-align: right;
                        }
                        .value {
                            width: 660px;
                        }
                        &:first-child {
                            margin-top: 10px;
                        }
                    }
                }
            }
            a {
                color: $Brand600;
                text-decoration: none;
            }
        }
    }
    .foot {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 136px;
        padding-top: 64px 0 48px 0;
        box-sizing: border-box;
        .footInfo {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 1216px;
            height: 24px;
            p {
                font-family: "Inter-Regular" !important;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                color: $Gray400;
            }
            .platform-area {
                display: flex;
                justify-content: space-between;
                width: 168px;
                .social-icon {
                    font-size: 24px;
                    cursor: pointer;
                    color: $Gray400;
                }
            }
        }
    }
}
.mobile {
    width: 100%;
    box-sizing: border-box;
    padding: 0.64rem 0;
    .head {
        padding-bottom: 0.64rem;
        box-sizing: border-box;
        .headInfo {
            text-align: center;
            .headSubTitle {
                font-family: "Inter-Medium" !important;
                font-size: 0.14rem;
                font-weight: 500;
                line-height: 0.2rem;
                color: $Brand600;
                margin-bottom: 0.12rem;
            }
            .headTitle {
                font-family: "Inter-Semibold" !important;
                font-size: 0.36rem;
                font-weight: 600;
                line-height: 0.44rem;
                color: $Gray1200;
                margin-bottom: 0.16rem;
            }
            .headText {
                font-family: "Inter-Regular" !important;
                font-size: 0.18rem;
                font-weight: 400;
                line-height: 0.28rem;
                color: $Gray700;
            }
        }
    }
    .body {
        width: 100%;
        padding: 0 0.16rem;
        box-sizing: border-box;
        .bodyInfo {
            width: 100%;
            font-family: "Inter-Regular";
            font-size: 0.16rem;
            font-weight: 400;
            line-height: 0.24rem;
            color: $Gray700;
            h2 {
                font-family: "Inter-Medium" !important;
                font-size: 0.24rem;
                font-weight: 500;
                line-height: 0.32rem;
                color: $Gray1200;
                margin: 0.32rem 0 0.16rem 0;
            }
            h3 {
                color: $Gray1200;
                font-family: "Inter-Medium" !important;
                font-size: 0.18rem;
                font-weight: 500;
                line-height: 0.28rem;
                margin: 0.08rem 0;
            }
            ul {
                width: 100%;
                padding: 0 0 0 0.05rem;
                li {
                    display: flex;
                    justify-content: space-between;
                    width: 90%;
                    list-style-type: none;
                    .index {
                        width: 0.24rem;
                        text-align: right;
                    }
                    .value {
                        width: 94%;
                    }
                }
                ul {
                    li {
                        &:first-child {
                            margin-top: 0.1rem;
                        }
                    }
                }
            }
            a {
                color: $Brand600;
                text-decoration: none;
            }
        }
    }
    .foot {
        height: 1.92rem;
        width: 100%;
        padding: 0.48rem 0;
        box-sizing: border-box;
        .footInfo {
            display: flex;
            flex-direction: column-reverse;
            align-items: center;
            .platform-area {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 1.68rem;
                margin-bottom: 0.24rem;
                .social-icon {
                    font-size: 0.24rem;
                    cursor: pointer;
                    color: $Gray400;
                }
            }
            p {
                font-family: "Inter-Regular" !important;
                font-size: 0.16rem;
                font-weight: 400;
                line-height: 0.24rem;
                text-align: center;
                color: $Gray400;
            }
        }
    }
}
</style>
